import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';

@Component({
  selector: 'app-select-company-role',
  templateUrl: './select-company-role.component.html',
  styleUrls: ['./select-company-role.component.scss'],
})
export class SelectCompanyRoleComponent implements OnInit {

  loaded_roles = false;
  single_role_question = true;
  option_selected = '';
  current_client_index = 0;
  roles = [];
  @Input() contacts = [];
  @Input() companies = [];
  return_data = [];

  constructor(private modalController: ModalController,private apiService: ApiService) { }

  ngOnInit() {
    this.GetData();
  }

  async GetData() {
    let role_data: any = await this.apiService.GetRoles();
    if(role_data && role_data.success) this.roles = role_data.data;

    this.ResetCompaniesSelectedRoles();
    this.loaded_roles = true;
  }

  Close() {
    this.modalController.dismiss(null);
  }

  async BackToFirst() {
    this.current_client_index = 0;
    this.single_role_question = true;
    this.option_selected = '';
  }

  async SelectIndividualRoles() {
    this.single_role_question = false;
    this.option_selected = 'individual_roles';
  }

    ResetCompaniesSelectedRoles() {
    if (this.roles && this.roles.length > 0) {
      const firstGuid = this.roles[0].guid;
      if (firstGuid && Array.isArray(this.companies)) {
        this.companies.forEach(company => {
          company.selected_role_guid = firstGuid;
        });
      }
    }
  }


  async AssignAndMoveToNext() {
    const client = this.GetCurrentClient();
    if (!client) return;

    const client_guid = client.guid ?? client.client_guid ?? client.id ?? null;
    this.companies.forEach(company => {
      const company_guid = company.guid ?? company.company_guid ?? company.id ?? null;
      const role_guid = company.selected_role_guid ?? null;

      // push a new plain object (no references)
      this.return_data.push({
      client_guid: client_guid,
      company_guid: company_guid,
      role_guid: role_guid
      });
    });
    this.ResetCompaniesSelectedRoles();
    this.current_client_index++;
  }

  async BackIndividual() {
    this.current_client_index--;
    const client = this.GetCurrentClient();
    const client_guid = client.guid ?? client.client_guid ?? client.id ?? null;

      this.companies.forEach(company => {
        const company_guid = company.guid ?? company.company_guid ?? company.id ?? null;

        const idx = this.return_data.findIndex(item =>
          item.client_guid === client_guid && item.company_guid === company_guid
        );
        console.log("Found index:", idx);

        if (idx !== -1) {
          const [found] = this.return_data.splice(idx, 1);
          company.selected_role_guid = found.role_guid;
        }
        else{
          const firstGuid = this.roles[0].guid;
          company.selected_role_guid = firstGuid;
        } 
    });
  }

  async FinishAssignments() {
    this.modalController.dismiss(this.return_data);
  }

  async FinishAssignmentsSame() {
    this.return_data = [];
    this.contacts.forEach(client => {
      const client_guid = client.guid ?? client.client_guid ?? client.id ?? null;
      this.companies.forEach(company => {
        const company_guid = company.guid ?? company.company_guid ?? company.id ?? null;
        const role_guid = company.selected_role_guid ?? null;

        // push a new plain object (no references)
        this.return_data.push({
        client_guid: client_guid,
        company_guid: company_guid,
        role_guid: role_guid
        });
      });
    });
    this.modalController.dismiss(this.return_data);
  }



  GetCurrentClient() {
    return this.contacts[this.current_client_index];
  }


  async AssignSameRoleToAll() {
    this.single_role_question = false;
    this.option_selected = 'same_role_all';
  }

  async Log() {
    console.log("Return Data:", this.return_data);
  }



}
